import { render } from "./ProductSlider.vue?vue&type=template&id=4eac9f1c"
import script from "./ProductSlider.vue?vue&type=script&lang=js"
export * from "./ProductSlider.vue?vue&type=script&lang=js"

import "./ProductSlider.vue?vue&type=style&index=0&id=4eac9f1c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__